import { useNavigate, useOutletContext } from "react-router-dom";
import EventInfo from "../../../../components/sections/front/user-events-collections/EventInfo";
import TicketsList from "../../../../components/sections/front/user-tickets/TicketsList";

const TicketManage = () => {
  const navigate = useNavigate();
  const { event, eventLoading, selectedLanguage } = useOutletContext();

  if (!event?.data?._id && !eventLoading) {
    navigate(`/${selectedLanguage}/user/events`);
    return;
  }

  return (
    <div className="w-full relative flex flex-col lg:flex-row items-start gap-4 xl:gap-6">
      <div className="flex-shrink-0 w-full lg:w-72 xl:w-96 lg:top-28 lg:sticky">
        <EventInfo details={event} />
      </div>
      <div className="relative flex-shrink flex-grow">
        <TicketsList />
      </div>
    </div>
  );
};

export default TicketManage;
